
import React from 'react';
import './App.css';

function Contact() {
  return (
    <div className="contact-page" style={{ textAlign: 'center', padding: '20px' }}>
      <h1>Contact Us</h1>
      <p>Feel free to reach out to us through the following channels:</p>
      <p>
      Instagram:{' '}
      </p>
      <a href="https://www.instagram.com/thepersonaltrainersclub/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/qr_without_border.png"
          width={150}
          alt="QR Code to PTC"
          className="contact-instagram-qr"
          style={{ marginBottom: '20px' }}
        />
      </a>
      <p>
        Email us about issues or questions or feedback at {' '}
        <a href="mailto:info@heldsolutionsllc.net" className="contact-email-link" style={{ color: '#007bff', textDecoration: 'none' }}>
          info@heldsolutionsllc.net
        </a>
      </p>



              <div style={{ fontWeight: 'bold' }}>Who am I?</div>
              <div>I'm Alex, a solo software developer from Texas who loves the gym.
                <br />
                For the past few months I've dedicated myself to building this project.
                <br />
                 This is operated though Held Solutions LLC. 
              </div>



      {/* Copyright Held Solutions LLC 2025  */}
      <p style={{ marginTop: '40px', fontSize: '0.9em', color: '#666' }}>
        &copy; {new Date().getFullYear()} Held Solutions LLC. All rights reserved.
      </p>

    </div>
  );
}

export default Contact;